import * as React from 'react';

import './Form.css';

type FormProps = React.FormHTMLAttributes<HTMLFormElement>;

export const Form = React.forwardRef<HTMLFormElement, FormProps>(
  ({ children, className = '', ...props }, ref) => (
    <form className={`form-2024 ${className}`} ref={ref} {...props}>
      {children}
    </form>
  )
);

Form.displayName = 'Form';
